import { BrowserRouter, Routes, Route } from "react-router-dom";
import { HelmetProvider } from "react-helmet-async";
import { Toaster } from "sonner";

import { Layout } from "@/components/layout/Layout";
import { ScrollToTop } from "@/components/layout/ScrollToTop";
import Home from "@/pages/Home";
import About from "@/pages/About";
import Services from "@/pages/Services";
import TherapeuticAreasPage from "@/pages/TherapeuticAreasPage";
import OurSites from "@/pages/OurSites";
import Blogs from "@/pages/Blogs";
import BlogArticle from "@/pages/BlogArticle";
import Contact from "@/pages/Contact";
import Privacy from "@/pages/Privacy";

export default function App() {
  return (
    <HelmetProvider>
      <BrowserRouter>
        <ScrollToTop />
        <Layout>
          <Routes>
            <Route path="/" element={<Home />} />
            <Route path="/about" element={<About />} />
            <Route path="/services" element={<Services />} />
            <Route path="/therapeutic-areas" element={<TherapeuticAreasPage />} />
            <Route path="/our-sites" element={<OurSites />} />
            <Route path="/blogs" element={<Blogs />} />
            <Route
              path="/blogs/why-gcp-certification-is-essential"
              element={<BlogArticle />}
            />
            <Route path="/contact" element={<Contact />} />
            <Route path="/privacy" element={<Privacy />} />
            {/* Fallback: unknown routes render the home page */}
            <Route path="*" element={<Home />} />
          </Routes>
        </Layout>
        <Toaster richColors position="top-right" closeButton />
      </BrowserRouter>
    </HelmetProvider>
  );
}
